import { collectionEngineV1 } from '../apis';
const vouchersAPI = collectionEngineV1('/vouchers');
export const getTypes = () => vouchersAPI('GET', `/types`);
//# sourceMappingURL=vouchers.js.map